import { Trans } from '@lingui/macro'
import HYDRA_VAULT_ABI from 'abis/governance/HydraVault.json'
import REWARD_WALLET_ABI from 'abis/governance/RewardWallet.json'
import { useHydraVaultContract, useRewardWalletContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { CardGrid, SectionTitle } from '../styleds'

export default function VaultRewardsTab() {
  const vaultContract = useHydraVaultContract()
  const rewardWalletContract = useRewardWalletContract()

  return (
    <>
      <SectionTitle>
        <Trans>Vault & Rewards Contracts</Trans>
      </SectionTitle>

      <CardGrid>
        <ContractWidget
          title="HydraVault (0x...0106)"
          description="Fee collection vault. Handles relocation of collected fees to other contracts."
          contract={vaultContract}
          abi={HYDRA_VAULT_ABI as any}
          defaultFunction="relocateFees"
        />

        <ContractWidget
          title="RewardWallet (0x...0110)"
          description="Reward distribution wallet. Managers can distribute rewards and fund the wallet."
          contract={rewardWalletContract}
          abi={REWARD_WALLET_ABI as any}
          defaultFunction="distributeReward"
        />
      </CardGrid>
    </>
  )
}
